import { bl_fi_internal_sales_refund_note_import_file_hdr_RowClass } from '../../../dbschema';
import { BaseContainerModel } from '../../base-container.model';

export class SalesRefundNoteFileImportContainerModel extends BaseContainerModel {
    bl_fi_internal_sales_refund_note_import_file_hdr: bl_fi_internal_sales_refund_note_import_file_hdr_RowClass = new bl_fi_internal_sales_refund_note_import_file_hdr_RowClass();
}